import React, { useEffect, useState, useRef, useMemo } from "react";

import { Link, NavLink, useLocation } from "react-router-dom";

import { getZoomData } from "../shared/_services/common.services";

import { useSnackbar } from "notistack";

import Loader from "./Loader";



function buildMeetingInfoFromLocationState(state) {

    const s = state ?? {};

    return {

        date: s.date ?? "",

        time: s.time ?? "",

        duration: s.duration ?? 0,

        userId: s.userId ?? "",

    };

}



function resolveMeetingsListUrl(userType, userId) {

    const base = "/meetings";

    if (!userId) {

        return base;

    }

    if (userType === "super-admin" || userType === "admin") {

        return `${base}/${userId}?isadmin=true`;

    }

    if (userType === "advisor") {

        return `${base}/${userId}`;

    }

    return base;

}



function applyAmPmToHours(hours, period) {

    if (period === "PM" && hours !== 12) {

        return hours + 12;

    }

    if (period === "AM" && hours === 12) {

        return 0;

    }

    return hours;

}



function formatMeetingDateTimeDisplay(meetingInfo) {

    const { date, time, duration } = meetingInfo;

    if (!date || !time || duration === 0) {

        return "Invalid Date/Time";

    }



    const startDate = new Date(date);

    const [timePart, period] = time.split(" ");

    let [hours, minutes] = timePart.split(":").map(Number);

    hours = applyAmPmToHours(hours, period);

    startDate.setHours(hours, minutes);



    const endDate = new Date(startDate);

    endDate.setMinutes(startDate.getMinutes() + duration);



    const dateOpts = { weekday: "long", year: "numeric", month: "long", day: "numeric" };

    const timeOpts = { hour: "numeric", minute: "numeric", hour12: true };

    const dateStr = startDate.toLocaleDateString("en-US", dateOpts);

    const startTimeStr = startDate.toLocaleTimeString("en-US", timeOpts);

    const endTimeStr = endDate.toLocaleTimeString("en-US", timeOpts);

    return `${dateStr}, ${startTimeStr} - ${endTimeStr}`;

}



function requestElementFullscreen(element) {

    if (!element) {

        return;

    }

    const request =

        element.requestFullscreen ||

        element.mozRequestFullScreen ||

        element.webkitRequestFullscreen ||

        element.msRequestFullscreen;

    if (request) {

        request.call(element);

    }

}



function triggerTextFileDownload(content, filename) {

    const blob = new Blob([content], { type: "text/plain" });

    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement("a");

    anchor.href = url;

    anchor.download = filename;

    document.body.appendChild(anchor);

    anchor.click();

    window.URL.revokeObjectURL(url);

}



const MeetingDetails = () => {

    const location = useLocation();

    const meetingId = location?.state?.id;



    const [meetingDetails, setMeetingDetails] = useState("");

    const [videoUrl, setVideoUrl] = useState("");

    const notesRef = useRef(null);

    const { enqueueSnackbar } = useSnackbar();

    const [meetingInfo] = useState(() => buildMeetingInfoFromLocationState(location.state));



    const currentUser = JSON.parse(localStorage.getItem("currentUser"))?.user;



    const meetingUrl = useMemo(

        () => resolveMeetingsListUrl(currentUser?.userType, meetingInfo.userId),

        [currentUser?.userType, meetingInfo.userId]

    );



    const getUserMeetingDetails = async () => {

        const response = await getZoomData(meetingId);

        setMeetingDetails(response.data);

        const downloadUrl = response?.data?.recording[0]?.download_url;

        setVideoUrl(downloadUrl);

    };



    useEffect(() => {

        getUserMeetingDetails();

    }, []);



    const formattedRange = formatMeetingDateTimeDisplay(meetingInfo);



    const handleDownloadSummary = () => {

        const summary = meetingDetails?.chatAndTranscript?.summary;

        if (!summary) {

            enqueueSnackbar("No summary available to download.");

            return;

        }

        triggerTextFileDownload(summary, "meeting-summary.txt");

    };



    const handleExpandClick = () => {

        requestElementFullscreen(notesRef.current);

    };



    if (!meetingDetails) {

        return <Loader />;

    }



    return (

        <div className="meeting-detail">

            <div className="page-header">

                <h2>Meetings</h2>

                <p>Your complete log of past, present, and upcoming meetings.</p>

            </div>

            <div className="meeting-detail-header mt-3 mb-4 d-flex px-4">

                <NavLink to={meetingUrl} className="common-back-btn mr-3">

                    <i className="fa fa-angle-left"></i>

                </NavLink>

                <h5 className="f-400 mt-2">{formattedRange}</h5>

            </div>



            <div className="row px-4">

                <div className="col-8">

                    <div className="meeting-vdo mb-3">

                        <video className="w-100" src={videoUrl} controls loop muted></video>

                    </div>

                    <div className="ast-card">

                        <div className="d-flex justify-content-between mb-3">

                            <h5>Notes</h5>

                            <div className="d-flex">

                                <Link className="download cursor-pointer mr-3" onClick={handleDownloadSummary}>

                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

                                        <path d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.979 19.804 4.588 19.413C4.197 19.022 4.001 18.551 4 18V15H6V18H18V15H20V18C20 18.55 19.804 19.021 19.413 19.413C19.022 19.805 18.551 20.001 18 20H6Z" fill="black" />

                                    </svg>

                                </Link>

                                <Link className="expand cursor-pointer" onClick={handleExpandClick}>

                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

                                        <path d="M12.306 16.592L12.271 18.592L5.272 18.47L5.395 11.47L7.395 11.506L7.332 15.091L15.226 7.467L11.694 7.406L11.729 5.406L18.728 5.528L18.605 12.528L16.605 12.492L16.669 8.854L8.721 16.53L12.306 16.592Z" fill="black" />

                                    </svg>

                                </Link>

                            </div>

                        </div>

                        <div style={{ marginBottom: "20px", marginTop: "0px", borderTop: "1px solid #ebebeb" }}></div>

                        <p ref={notesRef} className="meeting-notes">{meetingDetails?.chatAndTranscript?.summary || "No summary available."}</p>

                    </div>

                </div>

                <div className="col-4">

                    <div className="ast-card transcript-sticky">

                        <h5 className="mb-4">Transcript</h5>

                        <div style={{ marginBottom: "20px", marginTop: "0px", borderTop: "1px solid #ebebeb" }}></div>

                        <div className="transcript-box-list mini-scroll-bar">

                            {meetingDetails?.chatAndTranscript?.transcript?.transcription?.length > 0 ? (

                                meetingDetails.chatAndTranscript.transcript.transcription.map((item) => (

                                    <div key={item?._id} className="single-transcript-box d-flex">

                                        <div className="profile-pic mr-3">

                                            <h3>{item.speaker?.split(" ").map((name) => name[0]).join("")}</h3>

                                        </div>

                                        <div className="transcript-msg">

                                            <p>{item.message}</p>

                                        </div>

                                    </div>

                                ))

                            ) : (

                                <p>No transcript available.</p>

                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};



export default MeetingDetails;

